export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" className={className} aria-hidden="true">
      <path
        d="M18 2L22.5 13.5L34 18L22.5 22.5L18 34L13.5 22.5L2 18L13.5 13.5L18 2Z"
        stroke="#D4AF37"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18" cy="18" r="4" fill="#D4AF37" />
    </svg>
  );
}

export function Logo({ compact = false }) {
  return (
    <a href="/" data-testid="brand-logo" className="flex items-center gap-3 group">
      <LogoMark size={compact ? 26 : 32} className="transition-transform duration-700 group-hover:rotate-90" />
      <span className="leading-none">
        <span className={`block font-serif-lux tracking-[0.18em] text-amber-100 ${compact ? "text-base" : "text-lg"}`}>
          AUREUS
        </span>
        {!compact && (
          <span className="block font-mono-lux text-[9px] tracking-[0.35em] text-amber-500/80 mt-1">
            EXECUTIVE CHAUFFEUR
          </span>
        )}
      </span>
    </a>
  );
}
